import { ApiClient } from "@/services/client";

let client = new ApiClient();

export default {
  get() {
    return client.get(`Permissions?permissionType=0`);
  },
};
